<template>
    <Card title="Pago a plazos">
        <div class="tw:space-y-4">
            <ToggleSwitch
                :value="modelValue.activar_pago_plazos"
                @input="updateField('activar_pago_plazos', $event)"
            >
                Activar pago a plazos
            </ToggleSwitch>

            <template v-if="modelValue.activar_pago_plazos">
                <BaseMultiselect
                    label="Frecuencia de cargos"
                    :value="modelValue.frecuencia_ids?.[0] ?? null"
                    :options="frecuencias"
                    label-key="frecuencia_formatted"
                    value-key="id"
                    :multiple="false"
                    :loading="frecuenciasLoading"
                    rules="required"
                    @input="updateField('frecuencia_ids', $event != null ? [$event] : [])"
                />

                <div class="tw:flex tw:gap-4">
                    <div class="tw:flex-1">
                        <BaseInputNumber
                            label="Mínimo de plazos"
                            :value="modelValue.min_cantidad_plazos"
                            :step="1"
                            rules="required"
                            @input="updateField('min_cantidad_plazos', $event)"
                        />
                    </div>
                    <div class="tw:flex-1">
                        <BaseInputNumber
                            label="Máximo de plazos"
                            :value="modelValue.max_cantidad_plazos"
                            :step="1"
                            rules="required"
                            @input="updateField('max_cantidad_plazos', $event)"
                        />
                    </div>
                </div>
            </template>
        </div>
    </Card>
</template>

<script setup>
    import Card from '@/modules/admin/ui/Card.vue'
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue'
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue'
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue'

    const props = defineProps({
        modelValue: {
            type: Object,
            required: true
        },
        frecuencias: {
            type: Array,
            default: () => []
        },
        frecuenciasLoading: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['update:modelValue'])

    function updateField(field, value) {
        emit('update:modelValue', { ...props.modelValue, [field]: value })
    }
</script>
